/* The Collector Edit — sub-category slider v2.
   Selection rules:
     brand (chanel)            -> brand's category collections (graph)
     brand x category (chanel-bags) -> "All {Brand}" + ICONIC MODEL collections first + brand's product-types
     brand x type (chanel-backpacks)-> "All {Brand} {Category}" + brand's OTHER types in category
     pure type (crossbody-bags, hobos) -> BRAND tiles (Meili brand facet inside the collection)
     big category (bags)       -> the category's product-types (graph)
     sale                      -> % circles
     anything else (vintage-*) -> Meili product_type facet INSIDE the collection
   Images: always taken from items INSIDE the tile's own collection/filter — a tile on a
   brand-scoped page can never show another brand's product. Tiles lacking an image get one
   fetched from their own collection. Sliders with <2 tiles do not render. */
(function () {
  // handle -> meili filter. Brand x category collections are served by a
  // custom.meili_filter metafield, NOT ce_collections membership — without this
  // their slider tiles query the wrong field and render blank (76 of them).
  if (!window.CE_COLL_FILTERS) {
    window.CE_COLL_FILTERS = {};
    try {
      fetch('/cdn/shop/t/5/assets/ce-collection-filters.json')
        .then(function (r) { return r.json(); })
        .then(function (m) { window.CE_COLL_FILTERS = m || {}; })
        .catch(function () {});
    } catch (e) {}
  }
  'use strict';
  var mount = document.getElementById('ce-subcat-mount');
  if (!mount) return;
  var handle = (mount.dataset.handle || '').trim();
  if (!handle) return;
  var GRAPH = mount.dataset.graph || '';

  var SEARCH = 'https://search.collectoredit.com';
  var TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZWFyY2hSdWxlcyI6eyJwcm9kdWN0cyI6eyJmaWx0ZXIiOiJzdG9yZXMgPSBjb2xsZWN0b3JlZGl0In19LCJhcGlLZXlVaWQiOiI0M2ZlY2Y1Mi02YWMwLTRkNTAtOWNjYi1lMGViZGY4YjIzNjYifQ.d_kwOHo_K8a-Ngz_EF2AHuUhIfBHWsbdbZLV9seHW6s';
  var INDEX = 'products';

  // Iconic model collections shown FIRST on brand-bag pages (handle -> [[collection, label], ...])
  var MODELS_FIRST = {
    'louis-vuitton-accessories': [['louis-vuitton-sunglasses','Sunglasses']],
    'dior-accessories': [['dior-sunglasses','Sunglasses']],
    'chanel-bags': [['chanel-classic-flap','Classic Flap'],['chanel-boy-bags','Boy Bag'],['chanel-19-bags','Chanel 19'],['chanel-reissue-255','2.55 Reissue'],['chanel-wallet-on-chain','Wallet on Chain'],['chanel-coco-handle-bags','Coco Handle'],['chanel-deauville','Deauville']],
    'louis-vuitton-bags': [['louis-vuitton-speedy-bags','Speedy'],['louis-vuitton-neverfull','Neverfull'],['louis-vuitton-alma-bags','Alma'],['louis-vuitton-keepall-bags','Keepall'],['louis-vuitton-pochette-bags','Pochette'],['louis-vuitton-pochette-metis-bags','Pochette Métis'],['louis-vuitton-noe-bags','Noé'],['louis-vuitton-on-the-go-bags','OnTheGo'],['louis-vuitton-capucines-bags','Capucines'],['louis-vuitton-reverse-monogram','Reverse Monogram']],
    'hermes-bags': [['hermes-birkin','Birkin'],['hermes-kelly','Kelly'],['hermes-constance-bags','Constance'],['hermes-evelyne-bags','Evelyne'],['hermes-garden-party-bags','Garden Party'],['hermes-picotin-bags','Picotin'],['hermes-bolide-bags','Bolide'],['hermes-herbag','Herbag']],
    'gucci-bags': [['gucci-marmont-bags','GG Marmont'],['gucci-ophidia-bags','Ophidia'],['gucci-jackie-bags','Jackie'],['gucci-dionysus-bags','Dionysus'],['gucci-horsebit-bags','Horsebit'],['gucci-soho-bags','Soho'],['gucci-bamboo-bags','Bamboo']],
    'dior-bags': [['dior-lady-dior-bags','Lady Dior'],['dior-saddle-bags','Saddle'],['dior-book-tote-bags','Book Tote'],['dior-caro-bags','Caro'],['dior-30-montaigne-bags','30 Montaigne']],
    'prada-bags': [['prada-galleria-bags','Galleria'],['prada-re-edition-bags','Re-Edition']],
    'celine-bags': [['celine-luggage-bags','Luggage'],['celine-triomphe-bags','Triomphe'],['celine-trapeze-bags','Trapeze'],['celine-box-bags','Box'],['celine-nano-bags','Nano']],
    'fendi-bags': [['fendi-baguette-bags','Baguette'],['fendi-peekaboo-bags','Peekaboo'],['fendi-by-the-way-bags','By The Way']],
    'bottega-veneta-bags': [['bottega-jodie-bags','Jodie'],['bottega-cassette','Cassette'],['bottega-pouch','Pouch'],['bottega-arco','Arco']],
    'loewe-bags': [['loewe-puzzle-bags','Puzzle'],['loewe-hammock-bags','Hammock'],['loewe-gate-bags','Gate'],['loewe-amazona-bags','Amazona'],['loewe-flamenco-bags','Flamenco']],
    'saint-laurent-bags': [['saint-laurent-loulou-bags','Loulou'],['saint-laurent-kate-bags','Kate'],['saint-laurent-le-5-a-7-bags','Le 5 à 7']]
  };

  function ready() { var sec = mount.closest('.ce-subcat-sec'); if (sec) sec.classList.add('is-ready'); }
  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : s); return d.innerHTML; }
  function slug(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''); }
  function meili(body) {
    return fetch(SEARCH + '/indexes/' + INDEX + '/search', {
      method: 'POST', headers: { 'Authorization': 'Bearer ' + TOKEN, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  // The collection page's REAL Meilisearch filter (metafield) — falls back to membership tag.
  function colFilter() {
    var sp = document.getElementById('CeSearchPage');
    var mf = sp && sp.dataset ? (sp.dataset.meiliFilter || '') : '';
    return mf.trim() ? mf.trim() : "ce_collections = '" + handle + "'";
  }

  function setupArrows(track) {
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'ce-subcat__arrow ce-subcat__arrow--prev'; prev.setAttribute('aria-label', 'Previous'); prev.innerHTML = '‹';
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'ce-subcat__arrow ce-subcat__arrow--next'; next.setAttribute('aria-label', 'Next'); next.innerHTML = '›';
    mount.appendChild(prev); mount.appendChild(next);
    function move(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' }); }
    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    function upd() { var max = track.scrollWidth - track.clientWidth - 2; prev.classList.toggle('is-hidden', track.scrollLeft <= 2); next.classList.toggle('is-hidden', max <= 2 || track.scrollLeft >= max); }
    track.addEventListener('scroll', upd); window.addEventListener('resize', upd);
    track.querySelectorAll('img').forEach(function (im) { im.addEventListener('load', upd); im.addEventListener('error', upd); });
    try { new ResizeObserver(upd).observe(track); } catch (e) {}
    setTimeout(upd, 300); setTimeout(upd, 1200); upd();
  }

  /* items: [{h, t, im, u?, f?}] — h collection handle, u explicit link, f explicit image filter.
     Any tile without an image (or with a duped image) gets one fetched from its own collection. */
  function renderTiles(items) {
    if (!items || items.length < 2) return false;
    var used = {}, fixQueue = [];
    items.forEach(function (it, i) {
      var k = it.im ? it.im.split('?')[0] : '';
      if (!k || used[k]) { fixQueue.push(i); it.im = ''; } else { used[k] = 1; }
    });
    var track = document.createElement('div'); track.className = 'ce-subcat__track';
    items.forEach(function (it, i) {
      var a = document.createElement('a'); a.href = it.u || ('/collections/' + encodeURIComponent(it.h)); a.className = 'ce-subcat__tile'; a.setAttribute('data-ti', i);
      a.innerHTML = '<span class="ce-subcat__img">' +
        (it.im ? '<img loading="lazy" src="' + esc(it.im) + '" alt="' + esc(it.t) + '">' : '<span class="ce-subcat__ph"></span>') +
        '</span><span class="ce-subcat__name">' + esc(it.t) + '</span>';
      track.appendChild(a);
    });
    mount.appendChild(track); setupArrows(track); ready();
    fixQueue.forEach(function (i) {
      var it = items[i];
      var f = it.f || ("ce_collections = '" + it.h + "'");
      meili({ q: '', filter: f, limit: 10, attributesToRetrieve: ['image_ce'] }).then(function (d) {
        var pick = '';
        ((d && d.hits) || []).some(function (h) {
          var k = (h.image_ce || '').split('?')[0];
          if (h.image_ce && !used[k]) { used[k] = 1; pick = h.image_ce; return true; }
          return false;
        });
        if (!pick) return;
        var slot = track.querySelector('[data-ti="' + i + '"] .ce-subcat__img');
        if (slot) slot.innerHTML = '<img loading="lazy" src="' + esc(pick) + '" alt="' + esc(it.t) + '">';
      }).catch(function () {});
    });
    return true;
  }

  // ---- Sale: Fashionphile-style % circles ----
  if (handle === 'sale') {
    var tiers = (mount.dataset.saleTiers || '10,20,30,40,50,60,70').split(',')
      .map(function (s) { return parseInt(s, 10); }).filter(function (n) { return n > 0; });
    if (tiers.length) {
      var t = document.createElement('div'); t.className = 'ce-subcat__track';
      tiers.forEach(function (p) {
        var a = document.createElement('a'); a.href = '/collections/sale'; a.className = 'ce-subcat__tile';
        a.innerHTML = '<span class="ce-subcat__pct"><b>' + p + '</b><span>% OFF</span></span>';
        t.appendChild(a);
      });
      mount.appendChild(t); setupArrows(t); ready();
    }
    return;
  }

  /* ---- Meili facet slider (images ALWAYS from inside this collection) ----
     mode 'types'  -> product_type tiles; dedicated brand-type/type collection link when the
                      graph has one for this context, else filtered link within the collection.
     mode 'brands' -> brand tiles; dedicated brand-type collection when it exists. */
  function facetSlider(g, mode, ctx) {
    var facetKey = mode === 'brands' ? 'brand' : 'product_type';
    var topN = 12;
    var base = colFilter();
    meili({ q: '', filter: base, facets: [facetKey], limit: 500, attributesToRetrieve: [facetKey, 'image_ce'] }).then(function (d) {
      var dist = (d.facetDistribution && d.facetDistribution[facetKey]) || {};
      var imgsByKey = {};
      (d.hits || []).forEach(function (h) { var v = h[facetKey]; if (v && h.image_ce) { (imgsByKey[v] = imgsByKey[v] || []).push(h.image_ce); } });
      var items = Object.keys(dist).map(function (key) {
        var link = '', fh = '';
        if (mode === 'brands') {
          var ded = null, bs = slug(key);
          if (g && g.typeBrands && ctx && ctx.p) {
            (g.typeBrands[ctx.p] || []).some(function (x) { if (x.h.indexOf(bs + '-') === 0) { ded = x.h; return true; } return false; });
          }
          link = ded ? '/collections/' + ded : '/collections/' + handle + '?f_brand=' + encodeURIComponent(key);
        } else {
          var dh = '';
          if (g && ctx && ctx.k === 'brandCat' && g.brandCatTypes) {
            ((g.brandCatTypes[ctx.b + '|' + ctx.c]) || []).some(function (x) { if (x.pt === key) { dh = x.h; return true; } return false; });
          }
          link = dh ? '/collections/' + dh : '/collections/' + handle + '?f_product_type=' + encodeURIComponent(key);
        }
        // image comes from THIS collection's own hits — never a global cross-brand photo
        return { name: key, count: dist[key], img: (imgsByKey[key] || [])[0] || '', u: link };
      })
        .filter(function (i) { return i.count > 0 && i.name; })
        .sort(function (a, b) { return b.count - a.count; }).slice(0, topN);
      var usedF = {};
      items.forEach(function (it) {
        var k = (it.img || '').split('?')[0];
        if (k && !usedF[k]) { usedF[k] = 1; return; }
        var alt = (imgsByKey[it.name] || []).filter(function (u) { return !usedF[u.split('?')[0]]; })[0];
        if (alt) { it.img = alt; usedF[alt.split('?')[0]] = 1; } else { it.img = ''; }
      });
      if (items.length < 2) return;
      var track = document.createElement('div'); track.className = 'ce-subcat__track';
      items.forEach(function (it) {
        var a = document.createElement('a'); a.href = it.u; a.className = 'ce-subcat__tile';
        a.innerHTML = '<span class="ce-subcat__img">' + (it.img ? '<img loading="lazy" src="' + it.img + '" alt="' + esc(it.name) + '">' : '<span class="ce-subcat__ph"></span>') + '</span><span class="ce-subcat__name">' + esc(it.name) + '</span>';
        track.appendChild(a);
      });
      mount.appendChild(track); setupArrows(track); ready();
    }).catch(function () {});
  }

  // ---- Graph-driven slider ----
  function graphSlider(g) {
    var CURATED = { 'fine-jewelry-edit': 1, 'iconic-footwear': 1, 'the-finishing-touch': 1 };
  var ctx = (!CURATED[handle]) && g.byHandle && g.byHandle[handle];
    if (!ctx) {
      // unclassified handle: type-scoped collections (crossbody-bags…) facet by BRAND —
      // faceting a single-type collection by product_type yields one tile and renders nothing
      var cf = colFilter();
      var mode = (handle === 'watches' || handle === 'fine-jewelry-edit' || handle === 'iconic-footwear' || (/product_type/.test(cf) && !/brand/.test(cf))) ? 'brands' : 'types';
      facetSlider(g, mode, null); return true;
    }
    var icons = [], seen = {};
    function add(o, label, noimg) {
      if (!o || !o.h || seen[o.h]) return;
      seen[o.h] = 1;
      icons.push({ h: o.h, t: label || o.t, im: noimg ? '' : (g.img || {})[o.h], f: (window.CE_COLL_FILTERS || {})[o.h] });
    }
    var k = ctx.k;
    if (k === 'brand') {
      (g.brandCats[ctx.b] || []).forEach(function (x) { add(x); });
    } else if (k === 'cat') {
      if (ctx.c === 'Watches') { facetSlider(g, 'brands', ctx); return true; }
      (g.catTypes[ctx.c] || []).forEach(function (x) { add(x); });
    } else if (k === 'brandCat') {
      var br = g.brand[ctx.b]; if (br) add(br, 'All ' + br.t);
      // iconic models first — images fetched from each model's own collection
      (MODELS_FIRST[handle] || []).forEach(function (m) { add({ h: m[0] }, m[1], true); });
      (g.brandCatTypes[ctx.b + '|' + ctx.c] || []).forEach(function (x) { add(x); });
      if (icons.length < 4) { facetSlider(g, 'types', ctx); return true; }
    } else if (k === 'brandType') {
      var bc = g.brandCat[ctx.b + '|' + ctx.c]; if (bc) add(bc, 'All ' + bc.t);
      (g.brandCatTypes[ctx.b + '|' + ctx.c] || []).forEach(function (x) { if (x.pt !== ctx.p) add(x); });
    } else if (k === 'type') {
      // pure product-type collections (crossbody-bags, hobos, vanity-bags...) -> BRAND tiles
      facetSlider(g, 'brands', ctx); return true;
    }
    if (!renderTiles(icons.slice(0, 12))) facetSlider(g, 'types', ctx);
    return true;
  }

  if (!GRAPH) { facetSlider(null, handle === 'watches' ? 'brands' : 'types', null); return; }
  fetch(GRAPH).then(function (r) { return r.json(); }).then(function (g) {
    graphSlider(g);
  }).catch(function () { facetSlider(null, 'types', null); });
})();
